import CLPhotos, { LogLevelName } from "@cloudike/web_photos"

import { USER_TOKEN_KEY_IN_STORAGE } from "../constants/user"
import { getCurrentAppConfigApiHost } from "../config/appConfig"

const options = {
  logLevel: LogLevelName.TRACE
}

const getConfig = () => {
  const authToken = localStorage.getItem(USER_TOKEN_KEY_IN_STORAGE)
  return {
    authToken: authToken || undefined,
    baseUrl: getCurrentAppConfigApiHost(),
    userAgent: `web-client ${process.env.APP_VERSION}`,
  }
}

export const getPhotoSdk = (): CLPhotos => {
  let sdk = null
  const config = getConfig()
  try {
    sdk = CLPhotos.init(options, config)
  } catch (e) {
    console.error(`Couldn't init photos sdk`, e)
  }

  return sdk as CLPhotos
}

export const destroyPhotoSdk = () => {
  CLPhotos.destroy()
}

